<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    ccorrentesList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      status: {
        required: helpers.withMessage("Campo status obrigatório, favor preencher.", required),
      },
      numero: {
        required: helpers.withMessage("Campo número obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted cbancs-table_0')
    // console.log(this.updating)
  },
  methods: {
    decimalParaFloat(event) {
      //console.log("decimalParaFloat")
      //console.log("event")
      //console.log(event)

      const valor = event.target.value;
      if (!valor) return;

      this.regSelecionado.saldoinicial = parseFloat(
          valor.replace(/\./g, '').replace(',', '.')
      );
    },

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.ccorrentesList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)

      this.regSelecionado.dtinicial = this.regSelecionado.dtinicial.substring(0, 10)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()

      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        //this.sh = false
        setTimeout(() => {
          this.$emit('alterareg', this.regSelecionado)
        }, 10);




      }
      this.submitted = false
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.showModal = true;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      let dateTime = moment(value, "YYYY-MM-DD").format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Número</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Último Lançamento</th>
        <th class="align-middle">Emite Boleto</th>
        <th class="align-middle">Remessa / Retorno</th>
        <th class="align-middle">Data Saldo Inicial</th>
        <th class="align-middle">Saldo Inicial(R$)</th>
        <th class="align-middle">Status</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in ccorrentesList" :key="data.id">
        <td>
          <a href="javascript: void(0);" class="text-body fw-bold" @click="editar(data.id)">{{
              data.id
            }}</a>
        </td>
        <td>{{ data.numero }} </td>
        <td>{{ data.descricao }} </td>
        <td>{{ formatDateTime(data.created_at) }} </td>
        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.emboleto === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.emboleto)  }}
              </span>
        </td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.remereto === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.remereto)  }}
              </span>
        </td>

        <td>{{ data.dtinicial ? formatDate(data.dtinicial) : "-"  }}</td>
        <td>{{ `R$ ${formatDecimal(data.saldoinicial)}`  }}</td>

        <td>
              <span
                  class="badge badge-pill badge-soft-success font-size-11"
                  :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                {{ nomeStatus(data.status)  }}
              </span>
        </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>

    <b-modal :title="regSelecionado.id != null ? `Editar Conta Bancária (${ regSelecionado.id })` : 'Criar Nova Conta Bancária'" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="conta">Conta</label>
              <input
                  id="conta"
                  v-model="regSelecionado.numero"
                  type="text"
                  class="form-control"
                  placeholder="Inserir número"
                  :class="{'is-invalid': submitted && v$.regSelecionado.numero.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.numero.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.numero.required.$message">
                  {{ v$.regSelecionado.numero.required.$message }}
                </span>
              </div>
            </div>
          </div>
          
          <div class="col-6">
            <div class="mb-3">
              <label for="dvconta">Digito verificador da conta</label>
              <input
                  id="dvconta"
                  v-model="regSelecionado.dvconta"
                  type="text"
                  class="form-control"
                  placeholder="Inserir número"
                  :class="{'is-invalid': submitted && v$.regSelecionado.dvconta.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.dvconta.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.dvconta.required.$message">
                  {{ v$.regSelecionado.dvconta.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="tipo">Digito verificado</label>
              <input
                  id="tipo"
                  v-model="regSelecionado.dvconta"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Tipo"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="contrato">Contrato</label>
              <input
                  id="contrato"
                  v-model="regSelecionado.contrato"
                  type="text"
                  class="form-control"
                  placeholder="Inserir número"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="codbeneficiario">Código do Beneficiário</label>
              <input
                  id="codbeneficiario"
                  v-model="regSelecionado.codbeneficiario"
                  type="text"
                  class="form-control"
                  placeholder="Inserir número"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="agencia">Agência</label>
              <input
                  id="agencia"
                  v-model="regSelecionado.agencia"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Agência"/>

            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="postobeneficiario">Posto Beneficiário</label>
              <input
                  id="postobeneficiario"
                  v-model="regSelecionado.postobeneficiario"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Posto Beneficiário"/>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="selectStatus">Status</label>
              <b-form-select
                  id="selectStatus"
                  v-model="regSelecionado.status"
                  class="mb-3 form-select form-control"
                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">
                <b-form-select-option value="A">
                  Ativo
                </b-form-select-option>
                <b-form-select-option value="I">
                  Inativo
                </b-form-select-option>
                <b-form-select-option value="L">
                  Análise
                </b-form-select-option>
              </b-form-select>
              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">
                <span v-if="v$.regSelecionado.status.required.$message">
                  {{ v$.regSelecionado.status.required.$message }}
                </span>
              </div>

            </div>
          </div>

          <!--REMOÇÃO DA SELEÇÃO DO BANCO - CHAMADO 1459 -->
          <!--<div class="col-6">
            <div class="mb-3">
              <label for="selectBanco">Banco</label>
              <b-form-select
                  id="selectBanco"
                  v-model="regSelecionado.banco"
                  class="mb-3 form-select form-control">
                <b-form-select-option value="001">
                  Banco do Brasil
                </b-form-select-option>
                <b-form-select-option value="756">
                  Sicoob
                </b-form-select-option>
              </b-form-select>
            </div>
          </div>-->

          <div class="col-6" title="Data inicial de corte">
            <div class="mb-3">
              <label for="dtinicial">Data Inicial</label>
              <input
                  id="dtinicial"
                  v-model="regSelecionado.dtinicial"
                  type="date"
                  class="form-control"/>
            </div>
          </div>

          <div class="col-6" title="Saldo inicial do caixa">
            <div class="mb-3">
              <label for="saldoinicial">Saldo Inicial(R$)</label>
              <input
                  id="saldoinicial"
                  v-model="regSelecionado.saldoinicial"
                  type="text"
                  @blur="decimalParaFloat"
                  placeholder="R$ Saldo Inicial"
                  class="form-control"/>
            </div>
          </div>

<!--          <div class="col-6">-->
<!--            <div class="mb-3">-->
<!--              <label for="selectRemret">Remessa / Retorno</label>-->
<!--              <b-form-select-->
<!--                  id="selectRemret"-->
<!--                  v-model="regSelecionado.remereto"-->
<!--                  class="mb-3 form-select form-control">-->
<!--                <b-form-select-option value="A">-->
<!--                  Ativo-->
<!--                </b-form-select-option>-->
<!--                <b-form-select-option value="I">-->
<!--                  Inativo-->
<!--                </b-form-select-option>-->
<!--              </b-form-select>-->
<!--            </div>-->
<!--          </div>-->


          <div class="col-12">
            <div class="mb-3">
              <label for="client_id">Client ID</label>
              <input
                  id="client_id"
                  v-model="regSelecionado.client_id"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Client ID"/>

            </div>
          </div>

          <!-- Escopo -->
          <div class="col-12">
            <div class="mb-3">
              <label for="escopo">Escopo</label>
              <input
                  id="escopo"
                  v-model="regSelecionado.escopo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir Escopo"/>
            </div>
          </div>

        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>
  </div>

</template>
